<template>
    <div class="min-h-screen flex flex-col bg-stone-50">
        <div
            class="bg-gray-500 bg-[url('/assets/images/help/header-bg.jpg')] bg-center bg-cover bg-no-repeat bg-blend-multiply text-white"
        >
            <HomeSectionContainer class="px-6">
                <HelpCenterHeader :appName="appName" />

                <slot name="hero" />
            </HomeSectionContainer>
        </div>

        <main class="flex-1 bg-stone-50">
            <slot />
        </main>

        <Links
            :appName="appName"
            :openCookieSettingsElementId="openCookieSettingsElementId"
        />
    </div>
</template>

<script setup lang="ts">
    import HelpCenterHeader from '@/HelpCenter/Component/HelpCenterHeader.vue'
    import HomeSectionContainer from '@/HelpCenter/Component/HomeSectionContainer.vue'
    import Links from '@/Marketing/Shared/Component/Links.vue'

    interface HelpCenterLayoutProps {
        appName: string
        openCookieSettingsElementId: string
    }

    defineProps<HelpCenterLayoutProps>()
</script>
